import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { ContabilidadModule } from '../contabilidad/contabilidad.module';
import { AsignacionFacturasController } from './asignacion-facturas.controller';
import { AsignacionFacturasService } from './asignacion-facturas.service';
import { LiquidacionesController } from './liquidaciones.controller';
import { LiquidacionesService } from './liquidaciones.service';
import { RutasCobranzaController } from './rutas-cobranza.controller';
import { RutasCobranzaService } from './rutas-cobranza.service';
import { VendedoresCobradoresController } from './vendedores-cobradores.controller';
import { VendedoresCobradoresService } from './vendedores-cobradores.service';
import { ZonasCobranzaController } from './zonas-cobranza.controller';
import { ZonasCobranzaService } from './zonas-cobranza.service';

@Module({
  imports: [PrismaModule, ContabilidadModule],
  controllers: [
    VendedoresCobradoresController,
    ZonasCobranzaController,
    AsignacionFacturasController,
    LiquidacionesController,
    RutasCobranzaController,
  ],
  providers: [
    VendedoresCobradoresService,
    ZonasCobranzaService,
    AsignacionFacturasService,
    LiquidacionesService,
    RutasCobranzaService,
  ],
  exports: [
    VendedoresCobradoresService,
    ZonasCobranzaService,
    AsignacionFacturasService,
    LiquidacionesService,
    RutasCobranzaService,
  ],
})
export class VendedoresCobradoresModule {}
